import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';

function EnergyOfficials() {
  const { id: renergy_id, plantName } = useParams(); // 👈 Get renewable energy plant id from route
  const [officials, setOfficials] = useState([]);

  // ✅ Fetch officials
  useEffect(() => {
    const fetchOfficials = async () => {
      try {
        const res = await axios.get(`https://backend-zkgn.onrender.com/api/renewable_officials/${renergy_id}`);
        setOfficials(res.data);
      } catch (error) {
        console.error('Error fetching officials:', error.message);
      }
    };

    fetchOfficials();
  }, [renergy_id]);

  // ✅ Delete official
  const handleDelete = async (renergy_officials_id) => {
    if (window.confirm("Are you sure you want to delete this official?")) {
      try {
        await axios.delete(`https://backend-zkgn.onrender.com/api/renewable_officials/delete/${renergy_officials_id}`);
        setOfficials((prev) =>
          prev.filter((off) => off.renergy_officials_id !== renergy_officials_id)
        );
      } catch (err) {
        console.error("Delete failed:", err.message);
      }
    }
  };

  return (
    <div className="container-fluid my-5">
      <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">
        <h4 className="fw-bold text-tertiary mb-2">
          {officials.length} - Officials Found
        </h4>
        <Link to={`/add-energyofficial/${plantName}/${renergy_id}`} className="btn btn-primary">
          Add Renewable Energy Official
        </Link>
      </div>

      <div className="table-responsive">
        <table className="table table-bordered officials-table">
          <thead className="table-light">
            <tr>
              <th>Designation</th>
              <th>Official's Name</th>
              <th>Official's Email</th>
              <th>Phone Number</th>
              <th className="text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            {officials.length > 0 ? (
              officials.map((official) => (
                <tr key={official.renergy_officials_id}>
                  <td>{official.renergy_officials_designation}</td>
                  <td>{official.renergy_officials_name}</td>
                  <td>{official.renergy_officials_email}</td>
                  <td>{official.renergy_phone}</td>
                  <td className="text-center">
                    <Link
                      to={`/edit-energyofficial/${plantName}/${official.renergy_officials_id}/${renergy_id}`}
                      className="btn btn-link text-success me-2 p-0"
                    >
                      <i className="fa fa-edit"></i>
                    </Link>
                    <button
                      className="btn btn-link text-danger p-0"
                      onClick={() => handleDelete(official.renergy_officials_id)}
                    >
                      <i className="fa fa-trash"></i>
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center text-muted">
                  No officials found for this renewable energy plant.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default EnergyOfficials;
